/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { SubscriptionUpdateRequest as BackendCoreApiModelsAppSubscriptionUpdateRequest } from '../models/Backend/Core/Api/Models/App/subscription-update-request';
import { SimpleResponse as SharedKernelModelsSimpleResponse } from '../models/SharedKernel/Models/simple-response';

@Injectable({
  providedIn: 'root',
})
export class FakesBackendService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation updateFake
   */
  static readonly UpdateFakePath = '/api/fakes/update-subscription-fake';

  /**
   * Swagger generation.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateFake$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateFake$Plain$Response(params?: {
    body?: BackendCoreApiModelsAppSubscriptionUpdateRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, FakesBackendService.UpdateFakePath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * Swagger generation.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateFake$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateFake$Plain(params?: {
    body?: BackendCoreApiModelsAppSubscriptionUpdateRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.updateFake$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Swagger generation.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateFake$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateFake$Json$Response(params?: {
    body?: BackendCoreApiModelsAppSubscriptionUpdateRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, FakesBackendService.UpdateFakePath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * Swagger generation.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateFake$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateFake$Json(params?: {
    body?: BackendCoreApiModelsAppSubscriptionUpdateRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.updateFake$Json$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Path part for operation uploadDocumentFake
   */
  static readonly UploadDocumentFakePath = '/api/fakes/upload-document-fake';

  /**
   * Swagger generation.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `uploadDocumentFake$Plain()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  uploadDocumentFake$Plain$Response(params?: {
    body?: {

/**
 * Title
 */
'Title': string;

/**
 * Description
 */
'Description': string;

/**
 * File
 */
'File': Blob;

/**
 * Unique Identifier used by logging
 */
'CorrelationId'?: string;
}
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, FakesBackendService.UploadDocumentFakePath, 'post');
    if (params) {
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * Swagger generation.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `uploadDocumentFake$Plain$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  uploadDocumentFake$Plain(params?: {
    body?: {

/**
 * Title
 */
'Title': string;

/**
 * Description
 */
'Description': string;

/**
 * File
 */
'File': Blob;

/**
 * Unique Identifier used by logging
 */
'CorrelationId'?: string;
}
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.uploadDocumentFake$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Swagger generation.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `uploadDocumentFake$Json()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  uploadDocumentFake$Json$Response(params?: {
    body?: {

/**
 * Title
 */
'Title': string;

/**
 * Description
 */
'Description': string;

/**
 * File
 */
'File': Blob;

/**
 * Unique Identifier used by logging
 */
'CorrelationId'?: string;
}
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, FakesBackendService.UploadDocumentFakePath, 'post');
    if (params) {
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * Swagger generation.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `uploadDocumentFake$Json$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  uploadDocumentFake$Json(params?: {
    body?: {

/**
 * Title
 */
'Title': string;

/**
 * Description
 */
'Description': string;

/**
 * File
 */
'File': Blob;

/**
 * Unique Identifier used by logging
 */
'CorrelationId'?: string;
}
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.uploadDocumentFake$Json$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

}
